import React from 'react';
import { string, node, oneOf } from 'prop-types';
import { Heading, Link, Icon } from '@tesla/design-system-react';
import { iconSuccess, iconError } from '@tesla/design-system-icons';
import classnames from 'classnames';
import styles from './styles.module.css.js';

var propTypes = {
  /** Confirmation header */
  title: string,
  /** Smaller confirmation message or subheader */
  message: string,
  /** Optional url to direct link to. Used in conjuction with linkText */
  linkUrl: string,
  /** Optional link display text. Used in conjuction with linkUrl */
  linkText: string,
  /** Any React child node */
  children: node,
  /** Dictates html tag that wraps component */
  tag: string,
  /** type of message(success or error) */
  type: oneOf(['success', 'error'])
};
var defaultProps = {
  title: null,
  message: null,
  linkUrl: null,
  linkText: null,
  children: null,
  tag: 'main',
  type: 'success'
};

/**
 * Confirmation screen with checkmark icon
 * @extends {Component<Props>}
 */
function Confirmation(_ref) {
  var title = _ref.title,
    message = _ref.message,
    linkUrl = _ref.linkUrl,
    linkText = _ref.linkText,
    children = _ref.children,
    tag = _ref.tag,
    type = _ref.type;
  var Tag = tag;
  var icon = {
    success: /*#__PURE__*/React.createElement(Icon, {
      data: iconSuccess,
      color: "#12BB00"
    }),
    error: /*#__PURE__*/React.createElement(Icon, {
      data: iconError,
      color: "#ED4E3B"
    })
  }[type];
  return /*#__PURE__*/React.createElement(Tag, {
    className: "tds-layout tds-layout-3col-has_main--inset ".concat(styles.Container),
    "data-test": "confirmation"
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.Layout, 'tds-layout-item', 'tds-layout-main')
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.Icon
  }, icon), /*#__PURE__*/React.createElement(Heading, {
    is: "h1",
    looksLike: "h2",
    className: "".concat(styles.Title),
    "data-test": "confirmation-title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles.Text,
    "data-test": "confirmation-message"
  }, message), linkUrl && linkText && /*#__PURE__*/React.createElement("div", {
    className: styles.Text
  }, /*#__PURE__*/React.createElement(Link, {
    href: linkUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    "data-test": "confirmation-link"
  }, linkText)), children), /*#__PURE__*/React.createElement("div", {
    className: "tds-layout-item tds-layout-aside"
  }), /*#__PURE__*/React.createElement("div", {
    className: "tds-layout-item tds-layout-aside"
  }));
}
Confirmation.propTypes = propTypes;
Confirmation.defaultProps = defaultProps;

export { Confirmation as default };
